module.exports = __webpack_public_path__ + "img/foto_westkant.e6865a23.jpg";